module.exports = __webpack_public_path__ + "img/image_service_2.0024c77c.png";